import OtherAppianTransactionDocuments from "./other-appian-transaction-documents";

export default OtherAppianTransactionDocuments;
